<template>
  <div>
    <InputComponent class="form-group"
      type="text"
      for="input-first-name"
      label_text="First Name"
      attribute="First Name"
      placeholder="First Name"
      v-model="form.first_name"
      :v="$v.form.first_name" />

    <InputComponent class="form-group"
      type="text"
      for="input-last-name"
      label_text="Last Name"
      attribute="Last Name"
      placeholder="Last Name"
      v-model="form.last_name"
      :v="$v.form.last_name" />

    <InlineRadioComponent
      label_text="Gender"
      for="input-gender"
      :radioCategories="genderCategories"
      v-model="form.gender"/>

    <InputComponent class="form-group"
      type="text"
      for="input-mobile-number"
      label_text="Mobile Number"
      attribute="Mobile Number"
      placeholder="Mobile Number"
      v-model="form.mobile_number" />

    <InputComponent class="form-group"
      type="text"
      for="input-birth-date"
      label_text="Birth date"
      attribute="Birth date"
      placeholder="Birth date"
      v-model="form.birthdate" />

    <InputComponent class="form-group"
      type="text"
      for="input-occupation"
      label_text="Occupation"
      attribute="Occupation"
      placeholder="Occupation"
      v-model="form.occupation" />

    <InputComponent class="form-group"
      type="text"
      for="input-country"
      label_text="Country"
      attribute="Country"
      placeholder="Country"
      v-model="form.country" />

    <InputComponent class="form-group"
      type="text"
      for="input-province"
      label_text="Province"
      attribute="Province"
      placeholder="Province"
      v-model="form.province" />

    <InputComponent class="form-group"
      type="text"
      for="input-city"
      label_text="City"
      attribute="City"
      placeholder="City"
      v-model="form.city" />

    <InputComponent class="form-group"
      type="text"
      for="input-permanent-address"
      label_text="Permanent Address"
      attribute="Permanent Address"
      placeholder="Permanent Address"
      v-model="form.permanent_address" />

    <InputComponent class="form-group"
      type="text"
      for="input-present-address"
      label_text="Present Address"
      attribute="Present Address"
      placeholder="Present Address"
      v-model="form.present_address" />

    <section>
      <button @click="validateForm()" type="submit" class="btn btn-primary">
        Update
      </button>
    </section>

  </div>
</template>


<script>
import { required } from 'vuelidate/lib/validators'

import InputComponent from '@/components/form/InputComponent'
import InlineRadioComponent from '@/components/form/InlineRadioComponent'

export default {
  components: {
    InputComponent,
    InlineRadioComponent
  },
  props: {
    form: Object,
    genderCategories: Array,
    validateForm: Function
  },
  validations: {
    form: {
      first_name: { required },
      last_name: { required }
    }
  },
}

</script>



// WEBPACK FOOTER //
// src/containers/individual_profile/ProfileForm.vue